import React, { useEffect, useRef, useState } from 'react';

/**
 * Shared open/close/outside-click chrome for the multi-select dropdowns
 * (LookupMultiSelect, HierarchyNodeTreeMultiSelect). Collapsed by default --
 * closes on an outside click or Escape -- so a list of dozens of hierarchy
 * nodes or regulatory references doesn't permanently occupy the vertical space
 * an always-open checkbox list used to.
 */
function MultiSelectDropdown({ label, children, disabled }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const handlePointerDown = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') setOpen(false);
    };
    document.addEventListener('mousedown', handlePointerDown);
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('mousedown', handlePointerDown);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [open]);

  return (
    <div className="multiselect" ref={ref}>
      <button
        type="button"
        className="multiselect-toggle"
        onClick={() => setOpen((o) => !o)}
        disabled={disabled}
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <span className="multiselect-toggle-label">{label}</span>
        <span className="multiselect-toggle-caret" aria-hidden="true">▾</span>
      </button>
      {open && <div className="multiselect-panel">{children}</div>}
    </div>
  );
}

export default MultiSelectDropdown;
